import React from 'react'
import { ROW_DATE_FILTERS } from 'utils/constants'
import classnames from 'classnames'
import { Row, Col } from 'react-bootstrap'
import { DateRangePicker } from 'components'
import { kebabCase, snakeCase } from 'lodash'
import styled from 'styled-components'

const Dates = ({
  translate,
  handleSelectChange,
  defaultValue,
  selects,
}) => {
  return (
    <>
      {ROW_DATE_FILTERS.map((value, index) => (
        <Row
          key={`range-${kebabCase(value)}`}
          className={classnames({ 'mb-2': index < ROW_DATE_FILTERS.length - 1 })}
        >
          <StyledRange>
            <DateRangePicker
              onChange={(e) => handleSelectChange(e, value)}
              value={defaultValue?.[value] || selects[value]}
              label={translate(snakeCase(value))}
            />
          </StyledRange>
        </Row>
      ))}
    </>
  )
}

const StyledRange = styled(Col)`
  .active {
    background-color: ${({ theme }) => theme.palette.grayscale[7]};
    border: 1px solid ${({ theme }) => theme.palette.grayscale[5]};
    color: ${({ theme }) => theme.palette.grayscale[3]};
    &:hover {
      border-color: ${({ theme }) => theme.palette.grayscale[4]};
    }
  }
`


export default Dates
